function readOnlyLayout(layout) {
  const fields = {};
  for (const [name, field] of Object.entries(layout.fields)) {
    fields[name] = { ...field, readOnly: true };
  }
  return {
    ...layout,
    form_action: [],
    table_action: ["open"],
    autoSave: false,
    fields,
  };
}

export default readOnlyLayout;
